import React from 'react';
import {View, Text, TouchableOpacity, TextInput} from 'react-native';
import {globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import FastImage from "../../../common/FastImage";
import {smile_coin} from "../../../utils/images";


const CoinsBottomSheet = ({onBottomSheetClose, promoData, isSignUP}) => {
    return (
        <View style={{backgroundColor: Colors.tradexBlue, padding: 20}}>
            <FastImage
                style={{width: 50, height: 50}}
                source={smile_coin()}
            />
            <FormTextLabel
                labelStyles={{
                    ...globalFontStyle.appBlueHead,
                    marginTop: 10,
                    marginBottom: 5,
                    color: Colors.bgWhite,
                }}
                label={"Congratulations!"}
            />
            <FormTextLabel
                labelStyles={{...globalFontStyle.appFontTitleHead, color: Colors.bgWhite, marginBottom: 5}}
                label={promoData?.title}
            />
            {isSignUP && (<FormTextLabel
                labelStyles={{...globalFontStyle.appFontTitleRegular, color: Colors.bgWhite, marginBottom: 10,}}
                label={"as signup reward!"}
            />)}
            {promoData?.subtitle?.map((item, key) => {
                return (
                    <View key={key} style={{flexDirection: 'row'}}>
                        <FormTextLabel
                            labelStyles={{
                                ...globalFontStyle.appFontTitleRegular,
                                color: key%2 ? Colors.black : Colors.tradexBlue,
                                backgroundColor: key%2 ? "rgba(255, 220, 93, 1)" : Colors.bgWhite,
                                marginVertical: 5,
                                paddingHorizontal: 5,
                                paddingVertical: 2
                            }}
                            label={item}
                        />
                    </View>
                );
            })}
            <View style={{flexDirection: 'row', marginTop: 20}}>
                <TouchableOpacity
                    onPress={onBottomSheetClose}
                    style={{
                        textAlign: "center",
                        paddingVertical: 12,
                        paddingHorizontal: 15,
                        borderRadius: 8,
                        backgroundColor: Colors.bgWhite,

                        shadowColor: "#000",
                        shadowOffset: {
                            width: 2,
                            height: 2,
                        },
                        shadowOpacity: 0.25,
                        shadowRadius: 8,
                        elevation: 4,
                    }}>
                    <FormTextLabel
                        labelStyles={{...globalFontStyle.appFontSubHeading, color: Colors.tradexBlue,}}
                        label={"Thank You!"}
                    />
                </TouchableOpacity>
                <View style={{flex: 1}}/>
            </View>
        </View>
    );
};

export default CoinsBottomSheet;
